export const types = {
  DISABLED_FEATURES: 'disabledFeatures'
};
